import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice'; 
import wishlistReducer from './wishlistSlice'; // Import the new reducer
import cartSlice from './cartSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    wishlist: wishlistReducer,
    cart: cartSlice,
  },
});

export default store;